angular.module('tgaAdmin')
  .controller('EmbedController', [
    '$scope', '$state', '$location', 'userService', 'authService',
    function (
      $scope, $state, $location, userService, authService,
    ) {
      if (userService.isLoggedIn()) {
        $state.go('v1.games');
        return;
      }

      $scope.initialize = function () {
        if ($location.search().api_key) {
          let auth = authService.clearAuthentication();
          auth.isAuth = true;
          auth.token = $location.search().api_key;
          authService.setAuthentication(auth);

          userService.getCurrentUser().then(
            (user) => {
              auth = authService.getAuthentication();
              auth.isAuth = true;
              auth.username = user.username;
              auth.token = $location.search().api_key;
              auth.userId = user.id;
              authService.setAuthentication(auth);
              userService.setUser(user);
              $state.go('v1.games');
            },
          ).catch(() => {
            authService.clearAuthentication();
            $state.go('v1.login');
          });
        } else {
          $state.go('v1.login');
        }
      };

      $scope.initialize();
    },
  ]);
